define('models/shared/entityattributes/entityattribute',['backbone'
], function (Backbone) {
    var EntityAttribute = Backbone.Model.extend({
        parse: function (data) {
            var response = {};
            response.EntityID = data.EID;
            response.AttributeTypeID = data.ATID;
            response.AttributeValue = data.AV;
            return response;
        },
        save: function (attributes, options) {
            options = options || {};
            attributes = attributes || {};;

            var data = {};
            data.EID = this.attributes.EntityID;
            data.ATID = this.attributes.AttributeTypeID;
            data.AV = this.attributes.AttributeValue;

            this.attributes = data;

            return Backbone.Model.prototype.save.call(this, attributes, options);
        }
    });

    return EntityAttribute;
});


